var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('layout-tabbar',{attrs:{"activeColor":_vm.$colorConfig.primaryColor,"tab-list":_vm.tabbarList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }